var map = {
	"./Feet/TerribleBoots/TerribleBoots_L.fbx": 7450,
	"./Feet/TerribleBoots/TerribleBoots_R.fbx": 5116,
	"./Hands/TerribleGloves/TerribleGloves_L.fbx": 2886,
	"./Hands/TerribleGloves/TerribleGloves_R.fbx": 9376,
	"./Head/BallCapBackward/BallCapBackward.fbx": 8233,
	"./Head/BallCapForward/BallCapForward.fbx": 2567,
	"./Head/CheesyGlasses/CheesyGlasses.fbx": 5493,
	"./Head/ConeHat/ConeHat.fbx": 9637,
	"./Head/Headphones/Headphones.fbx": 9149,
	"./Head/Horns/Horns.fbx": 1153,
	"./Head/LibertySpikes/LibertySpikes.fbx": 3485,
	"./Head/MotorcycleHelmetLowPoly/MotorcycleHelmetLowPoly.fbx": 4209,
	"./Head/SantaHat/SantaHat.fbx": 3427,
	"./Head/Sideburns/Sideburns.fbx": 8125,
	"./Head/TopHat/TopHat.fbx": 6211,
	"./legs/TerriblePants/TerriblePants.fbx": 9296,
	"./torso/TerribleShirt/TerribleShirt.fbx": 8928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2641;